import React from 'react';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { connect } from 'react-redux';
import { saveProductToLinkIdx } from '../../../../store/links.store';
import linkplus from '../../../../../style/linkplus.png';
import link from '../../../../../style/link.png';


class ConnectDealElement extends React.Component {
  constructor(props) {
    super(props);
    this.defineSelectedProducts = this.defineSelectedProducts.bind(this);
  }

  defineSelectedProducts() {
    if (!this.props.linkExisting) {
      this.props.saveProductToLinkIdx();
    }
    this.props.startAtomsLinking();
  }

  render() {
    return (
      <Button
        id="addLink"
        className={'add-link-btn'}
        bsStyle={!!this.props.buttonType ? this.props.buttonType : 'primary'}
        style={this.props.buttonStyle}
        onClick={this.defineSelectedProducts}
      >
        {!!this.props.children
          ? ''
          : <span>
            <img src={link} className={'add-link-btn-icon'} alt="Transport" />
            <img src={linkplus} className={'add-link-btn-plus'} alt="Add transport" />
          </span>}
      </Button>
    );
  }
}

ConnectDealElement.propTypes = {
  saveProductToLinkIdx: React.PropTypes.func,
  saveProductToLinkTransportIdx: React.PropTypes.func,
  children: React.PropTypes.object,
  buttonType: React.PropTypes.string,
  buttonStyle: React.PropTypes.object,
  dealId: React.PropTypes.number,
  startAtomsLinking: React.PropTypes.func.isRequired,
  clearQuantity: React.PropTypes.func,
  linkExisting: React.PropTypes.bool,
  productIdx: React.PropTypes.number,
};

export default connect(
  () => ({}),
  (dispatch, props) => ({
    saveProductToLinkIdx() {
      saveProductToLinkIdx(dispatch, props.productIdx);
    },
  })
)(ConnectDealElement);
